import {
    get,
    put,
    post,
    Delete,
    axios,
} from "../ApiDecorator";

/**
 * 研修平台阶段管理 / 观思问配置 V2
 * 网关：/course/admin/v2/stage | /course/admin/v2/gsw
 */
const StageV2 = {
    // ---------- 阶段管理 ----------
    /** GET 项目信息（执行期 + 可选用户组） */
    getProjectInfo(data) {
        return get("/course/admin/v2/stage/projectInfo", data);
    },
    /** GET 阶段列表 */
    getStageList(data) {
        return get("/course/admin/v2/stage/list", data);
    },
    /** POST 新增 / 更新阶段 */
    saveStage(data) {
        return post("/course/admin/v2/stage/save", data);
    },
    /** PUT 启用 / 取消启用 */
    setStageEnabled(data) {
        return put("/course/admin/v2/stage/enabled", data);
    },
    /** PUT 批量排序 */
    sortStages(data) {
        return put("/course/admin/v2/stage/sort", data);
    },
    /** DELETE 删除阶段 */
    deleteStage(data) {
        return Delete("/course/admin/v2/stage/delete", data);
    },

    // ---------- 观思问配置 ----------
    /** GET 已启用阶段配置列表 */
    getGswList(data) {
        return get("/course/admin/v2/gsw/list", data);
    },
    /** GET 配置详情 */
    getGswDetail(data) {
        return get("/course/admin/v2/gsw/detail", data);
    },
    /** POST 保存配置（questions / answer / all） */
    saveGsw(data) {
        return post("/course/admin/v2/gsw/save", data);
    },
    /** PUT 学员端启用开关 */
    setGswFrontendEnabled(data) {
        return put("/course/admin/v2/gsw/frontendEnabled", data);
    },
    /** GET 观思问管理 · 提交汇总 */
    getGswSubmissionSummary(data) {
        return get("/course/admin/v2/gsw/submissionSummary", data);
    },
    /** GET 观思问管理 · 提交详情 */
    getGswSubmissionDetail(data) {
        return get("/course/admin/v2/gsw/submissionDetail", data);
    },
    /** POST 观思问管理 · 异步导出汇总 Excel */
    exportGswSubmissionAsync(data) {
        return post("/course/admin/v2/gsw/submissionExportAsync", data);
    },
    /** POST 观思问管理 · 异步导出详情 Excel */
    exportGswSubmissionDetailAsync(data) {
        return post("/course/admin/v2/gsw/submissionDetailExportAsync", data);
    },
    /** POST 观思问管理 · 异步导出个人明细 Excel */
    exportGswSubmissionRecordAsync(data) {
        return post("/course/admin/v2/gsw/submissionRecordExportAsync", data);
    },
    /** GET 观思问管理 · 导出任务状态 */
    getGswExportStatus(data) {
        return get("/course/admin/v2/gsw/exportStatus", data);
    },
    /** GET 观思问管理 · 下载导出文件（xlsx blob） */
    downloadGswExport(data) {
        const params = { ...data, noCache: new Date().getTime() };
        const query = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== "")
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join("&");
        return axios.get(`/course/admin/v2/gsw/exportDownload?${query}`, {
            responseType: "blob",
        });
    },
};

export default StageV2;
